import React from "react";
import "../styles/privacy_policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1 className="privacy-title">Privacy Policy for Skill Master</h1>
        <p className="last-updated">Last updated: November 3, 2025</p>
        
        <p className="intro-text">
          ISF Analytica & Informatica ("we", "our", or "us") operates the Skill Master mobile 
          application ("App"). This Privacy Policy describes how we collect, use, and protect 
          your information when you use our App.
        </p>

        <section className="policy-section">
          <h2 className="section-title">1. Information We Collect</h2>
          <p>We collect the following types of information to provide and improve our services:</p>
          <ul className="policy-list">
            <li>
              <strong>Personal Information:</strong> When you register or sign in, we collect 
              your name, email address, and phone number.
            </li>
            <li>
              <strong>Payment Information:</strong> We use Braintree (a PayPal service) for 
              payment processing. While we do not store your card or banking details directly, 
              Braintree may process limited data such as transaction ID and status to verify payments.
            </li>
            <li>
              <strong>App Usage Data:</strong> We may collect minimal non-identifiable technical 
              information (e.g., app version, error logs) only for improving app performance.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2 className="section-title">2. How We Use Your Information</h2>
          <p>We use your data for the following purposes:</p>
          <ul className="policy-list">
            <li>To create and manage your user account.</li>
            <li>To process payments securely via our FastAPI payment gateway integrated with Braintree.</li>
            <li>To provide access to learning content and features.</li>
            <li>To send important updates related to your account or purchases.</li>
            <li>To improve the quality and functionality of the app.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2 className="section-title">3. Data Sharing and Disclosure</h2>
          <p>
            We do not sell, rent, or trade your personal data to third parties. However, we may 
            share limited data with:
          </p>
          <ul className="policy-list">
            <li>Braintree Payments (for payment verification and security).</li>
            <li>Law enforcement authorities, if required by law or court order.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2 className="section-title">4. Data Security</h2>
          <p>
            We follow industry-standard security practices to protect your data from unauthorized 
            access, alteration, disclosure, or destruction. All communication between your device 
            and our servers is protected via SSL encryption.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">5. Data Retention</h2>
          <p>
            Your personal data is retained only for as long as necessary to provide you with the 
            app's services. You can request deletion of your data by contacting us at 
            isfinformaticaanalytica@gmail.com.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">6. Your Rights</h2>
          <p>
            You have the right to access, correct, or delete your personal data, withdraw consent 
            at any time, and contact us for clarification about our data handling practices.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">7. Children's Privacy</h2>
          <p>
            Our app is intended for students and professional learners aged 13 years and above. 
            We do not knowingly collect data from children under 13. If you believe we have 
            collected such data, please contact us for removal.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">8. Third-Party Links</h2>
          <p>
            Our App may contain links to third-party websites (such as Braintree or learning 
            resources). We are not responsible for their privacy practices and encourage you to 
            review their privacy policies separately.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be posted within 
            the App and on our official website. Your continued use of the App after changes 
            constitutes your acceptance of the revised policy.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">10. Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy, please contact:</p>
          <div className="contact-info">
            <p><strong>ISF Analytica & Informatica</strong></p>
            <p>Email: isfinformaticaanalytica@gmail.com</p>
            <p>Website: <a href="https://isfinformatica.com" target="_blank" rel="noopener noreferrer">https://isfinformatica.com</a></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;